import { render } from "./Carrito.vue?vue&type=template&id=68fc5ab4"
import script from "./Carrito.vue?vue&type=script&lang=js"
export * from "./Carrito.vue?vue&type=script&lang=js"

import "./Carrito.vue?vue&type=style&index=0&id=68fc5ab4&lang=scss"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__